/**
 * A resident cell's placement writes (`position`, `top`, `width`), guarded:
 * `DefaultBinder.onBind` places every resident cell on every bind, and an
 * unchanged inline value written again still dirties the cell's style (the
 * repeated identical inline writes the strip profile counted, F14). Returns
 * how many properties were actually written.
 */
export function placeCell(
  style: Pick<CSSStyleDeclaration, "getPropertyValue" | "setProperty">,
  position: string,
  top: string,
  width: string,
): number {
  let writes = 0;
  if (style.getPropertyValue("position") !== position) {
    style.setProperty("position", position);
    writes++;
  }
  if (style.getPropertyValue("top") !== top) {
    style.setProperty("top", top);
    writes++;
  }
  if (style.getPropertyValue("width") !== width) {
    style.setProperty("width", width);
    writes++;
  }
  return writes;
}
